import View from './View';

export { default as View, getLinearGradientStyles, getProgressBarStyles } from './View';
export * from './types';

export default View;
